module.exports = __webpack_public_path__ + "static/media/artist_pol-y_b.6913b0d4.png";